import type { Sku } from "../types";

/**
 * Alibaba Model Studio. Beijing and Virginia share one set of prices, below Singapore's; a model
 * Virginia doesn't serve has no Virginia SKU. A prompt in a higher band prices the whole call there.
 */
export const alibabaSkus: readonly Sku[] = [
  {
    id: "alibaba:qwen3.7-max:singapore:standard",
    billedBy: "alibaba",
    model: "qwen3.7-max",
    endpoint: "singapore",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.5,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.5,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.25,
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 3.125,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 7.5 },
    ],
  },
  {
    id: "alibaba:qwen3.7-max:virginia:standard",
    billedBy: "alibaba",
    model: "qwen3.7-max",
    endpoint: "virginia",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.65,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.33,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.165,
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.063,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 4.951 },
    ],
  },
  {
    id: "alibaba:qwen3.7-max:beijing:standard",
    billedBy: "alibaba",
    model: "qwen3.7-max",
    endpoint: "beijing",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.65,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.33,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.165,
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.063,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 4.951 },
    ],
  },
  {
    id: "alibaba:qwen3.7-plus:singapore:standard",
    billedBy: "alibaba",
    model: "qwen3.7-plus",
    endpoint: "singapore",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.4,
        promptTokens: { upTo: 256_000 },
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.08,
        promptTokens: { upTo: 256_000 },
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.04,
        promptTokens: { upTo: 256_000 },
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.5,
        promptTokens: { upTo: 256_000 },
      },
      {
        id: "output",
        meter: "output",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.6,
        promptTokens: { upTo: 256_000 },
      },
      {
        id: "uncachedInput.over-256k",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.2,
        promptTokens: { over: 256_000 },
      },
      {
        id: "implicitCacheRead.over-256k",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.24,
        promptTokens: { over: 256_000 },
      },
      {
        id: "explicitCacheRead.over-256k",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.12,
        promptTokens: { over: 256_000 },
      },
      {
        id: "cacheWrite5m.over-256k",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.5,
        promptTokens: { over: 256_000 },
      },
      {
        id: "output.over-256k",
        meter: "output",
        unit: "1M tokens",
        currency: "USD",
        amount: 4.8,
        promptTokens: { over: 256_000 },
      },
    ],
  },
  {
    id: "alibaba:qwen3.7-plus:virginia:standard",
    billedBy: "alibaba",
    model: "qwen3.7-plus",
    endpoint: "virginia",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.276,
        promptTokens: { upTo: 256_000 },
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.056,
        promptTokens: { upTo: 256_000 },
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.028,
        promptTokens: { upTo: 256_000 },
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.344,
        promptTokens: { upTo: 256_000 },
      },
      {
        id: "output",
        meter: "output",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.101,
        promptTokens: { upTo: 256_000 },
      },
      {
        id: "uncachedInput.over-256k",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.826,
        promptTokens: { over: 256_000 },
      },
      {
        id: "implicitCacheRead.over-256k",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.166,
        promptTokens: { over: 256_000 },
      },
      {
        id: "explicitCacheRead.over-256k",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.083,
        promptTokens: { over: 256_000 },
      },
      {
        id: "cacheWrite5m.over-256k",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.032,
        promptTokens: { over: 256_000 },
      },
      {
        id: "output.over-256k",
        meter: "output",
        unit: "1M tokens",
        currency: "USD",
        amount: 3.301,
        promptTokens: { over: 256_000 },
      },
    ],
  },
  {
    id: "alibaba:qwen3.7-plus:beijing:standard",
    billedBy: "alibaba",
    model: "qwen3.7-plus",
    endpoint: "beijing",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.276,
        promptTokens: { upTo: 256_000 },
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.056,
        promptTokens: { upTo: 256_000 },
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.028,
        promptTokens: { upTo: 256_000 },
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.344,
        promptTokens: { upTo: 256_000 },
      },
      {
        id: "output",
        meter: "output",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.101,
        promptTokens: { upTo: 256_000 },
      },
      {
        id: "uncachedInput.over-256k",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.826,
        promptTokens: { over: 256_000 },
      },
      {
        id: "implicitCacheRead.over-256k",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.166,
        promptTokens: { over: 256_000 },
      },
      {
        id: "explicitCacheRead.over-256k",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.083,
        promptTokens: { over: 256_000 },
      },
      {
        id: "cacheWrite5m.over-256k",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.032,
        promptTokens: { over: 256_000 },
      },
      {
        id: "output.over-256k",
        meter: "output",
        unit: "1M tokens",
        currency: "USD",
        amount: 3.301,
        promptTokens: { over: 256_000 },
      },
    ],
  },
  {
    id: "alibaba:qwen3.7-flash:singapore:standard",
    billedBy: "alibaba",
    model: "qwen3.7-flash",
    endpoint: "singapore",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.03,
        promptTokens: { upTo: 32_000 },
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.006,
        promptTokens: { upTo: 32_000 },
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.003,
        promptTokens: { upTo: 32_000 },
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.038,
        promptTokens: { upTo: 32_000 },
      },
      {
        id: "output",
        meter: "output",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.13,
        promptTokens: { upTo: 32_000 },
      },
      {
        id: "uncachedInput.over-32k",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.1,
        promptTokens: { over: 32_000, upTo: 256_000 },
      },
      {
        id: "implicitCacheRead.over-32k",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.02,
        promptTokens: { over: 32_000, upTo: 256_000 },
      },
      {
        id: "explicitCacheRead.over-32k",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.01,
        promptTokens: { over: 32_000, upTo: 256_000 },
      },
      {
        id: "cacheWrite5m.over-32k",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.125,
        promptTokens: { over: 32_000, upTo: 256_000 },
      },
      {
        id: "output.over-32k",
        meter: "output",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.4,
        promptTokens: { over: 32_000, upTo: 256_000 },
      },
      {
        id: "uncachedInput.over-256k",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.2,
        promptTokens: { over: 256_000 },
      },
      {
        id: "implicitCacheRead.over-256k",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.04,
        promptTokens: { over: 256_000 },
      },
      {
        id: "explicitCacheRead.over-256k",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.02,
        promptTokens: { over: 256_000 },
      },
      {
        id: "cacheWrite5m.over-256k",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.25,
        promptTokens: { over: 256_000 },
      },
      {
        id: "output.over-256k",
        meter: "output",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.8,
        promptTokens: { over: 256_000 },
      },
    ],
  },
  {
    id: "alibaba:qwen3.7-flash:virginia:standard",
    billedBy: "alibaba",
    model: "qwen3.7-flash",
    endpoint: "virginia",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.028,
        promptTokens: { upTo: 32_000 },
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.006,
        promptTokens: { upTo: 32_000 },
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.003,
        promptTokens: { upTo: 32_000 },
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.034,
        promptTokens: { upTo: 32_000 },
      },
      {
        id: "output",
        meter: "output",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.11,
        promptTokens: { upTo: 32_000 },
      },
      {
        id: "uncachedInput.over-32k",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.083,
        promptTokens: { over: 32_000, upTo: 256_000 },
      },
      {
        id: "implicitCacheRead.over-32k",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.017,
        promptTokens: { over: 32_000, upTo: 256_000 },
      },
      {
        id: "explicitCacheRead.over-32k",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.008,
        promptTokens: { over: 32_000, upTo: 256_000 },
      },
      {
        id: "cacheWrite5m.over-32k",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.103,
        promptTokens: { over: 32_000, upTo: 256_000 },
      },
      {
        id: "output.over-32k",
        meter: "output",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.33,
        promptTokens: { over: 32_000, upTo: 256_000 },
      },
      {
        id: "uncachedInput.over-256k",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.165,
        promptTokens: { over: 256_000 },
      },
      {
        id: "implicitCacheRead.over-256k",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.033,
        promptTokens: { over: 256_000 },
      },
      {
        id: "explicitCacheRead.over-256k",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.017,
        promptTokens: { over: 256_000 },
      },
      {
        id: "cacheWrite5m.over-256k",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.206,
        promptTokens: { over: 256_000 },
      },
      {
        id: "output.over-256k",
        meter: "output",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.66,
        promptTokens: { over: 256_000 },
      },
    ],
  },
  {
    id: "alibaba:qwen3.7-flash:beijing:standard",
    billedBy: "alibaba",
    model: "qwen3.7-flash",
    endpoint: "beijing",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.028,
        promptTokens: { upTo: 32_000 },
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.006,
        promptTokens: { upTo: 32_000 },
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.003,
        promptTokens: { upTo: 32_000 },
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.034,
        promptTokens: { upTo: 32_000 },
      },
      {
        id: "output",
        meter: "output",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.11,
        promptTokens: { upTo: 32_000 },
      },
      {
        id: "uncachedInput.over-32k",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.083,
        promptTokens: { over: 32_000, upTo: 256_000 },
      },
      {
        id: "implicitCacheRead.over-32k",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.017,
        promptTokens: { over: 32_000, upTo: 256_000 },
      },
      {
        id: "explicitCacheRead.over-32k",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.008,
        promptTokens: { over: 32_000, upTo: 256_000 },
      },
      {
        id: "cacheWrite5m.over-32k",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.103,
        promptTokens: { over: 32_000, upTo: 256_000 },
      },
      {
        id: "output.over-32k",
        meter: "output",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.33,
        promptTokens: { over: 32_000, upTo: 256_000 },
      },
      {
        id: "uncachedInput.over-256k",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.165,
        promptTokens: { over: 256_000 },
      },
      {
        id: "implicitCacheRead.over-256k",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.033,
        promptTokens: { over: 256_000 },
      },
      {
        id: "explicitCacheRead.over-256k",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.017,
        promptTokens: { over: 256_000 },
      },
      {
        id: "cacheWrite5m.over-256k",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.206,
        promptTokens: { over: 256_000 },
      },
      {
        id: "output.over-256k",
        meter: "output",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.66,
        promptTokens: { over: 256_000 },
      },
    ],
  },
  {
    id: "alibaba:qwen3.8-max:singapore:standard",
    billedBy: "alibaba",
    model: "qwen3.8-max",
    endpoint: "singapore",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 2,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.25,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.17,
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.5,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 6 },
    ],
  },
  {
    id: "alibaba:qwen3.8-max:virginia:standard",
    billedBy: "alibaba",
    model: "qwen3.8-max",
    endpoint: "virginia",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.65,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.206,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.137,
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.063,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 4.951 },
    ],
  },
  {
    id: "alibaba:qwen3.8-max:beijing:standard",
    billedBy: "alibaba",
    model: "qwen3.8-max",
    endpoint: "beijing",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.65,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.206,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.137,
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.063,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 4.951 },
    ],
  },
  {
    id: "alibaba:qwen3.8-flash:singapore:standard",
    billedBy: "alibaba",
    model: "qwen3.8-flash",
    endpoint: "singapore",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.15,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.016,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.016,
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.2,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 0.47 },
    ],
  },
  {
    id: "alibaba:qwen3.8-flash:virginia:standard",
    billedBy: "alibaba",
    model: "qwen3.8-flash",
    endpoint: "virginia",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.113,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.014,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.014,
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.177,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 0.382 },
    ],
  },
  {
    id: "alibaba:qwen3.8-flash:beijing:standard",
    billedBy: "alibaba",
    model: "qwen3.8-flash",
    endpoint: "beijing",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.113,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.014,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.014,
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.177,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 0.382 },
    ],
  },
  {
    id: "alibaba:qwen3.8-2.4t-a95b:singapore:standard",
    billedBy: "alibaba",
    model: "qwen3.8-2.4t-a95b",
    endpoint: "singapore",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 2,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.25,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.17,
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.5,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 6 },
    ],
  },
  {
    id: "alibaba:qwen3.8-2.4t-a95b:beijing:standard",
    billedBy: "alibaba",
    model: "qwen3.8-2.4t-a95b",
    endpoint: "beijing",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.65,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.206,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.137,
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 2.063,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 4.951 },
    ],
  },
  {
    id: "alibaba:qwen3.8-27b:singapore:standard",
    billedBy: "alibaba",
    model: "qwen3.8-27b",
    endpoint: "singapore",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.5,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.1,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.05,
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.625,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 3 },
    ],
  },
  {
    id: "alibaba:qwen3.8-27b:beijing:standard",
    billedBy: "alibaba",
    model: "qwen3.8-27b",
    endpoint: "beijing",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.424,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.085,
      },
      {
        id: "explicitCacheRead",
        meter: "explicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.042,
      },
      {
        id: "cacheWrite5m",
        meter: "cacheWrite5m",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.53,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 1.696 },
    ],
  },
  {
    id: "alibaba:glm-5.3:singapore:standard",
    billedBy: "alibaba",
    model: "glm-5.3",
    endpoint: "singapore",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.4,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.28,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 4.4 },
    ],
  },
  {
    id: "alibaba:glm-5.3:virginia:standard",
    billedBy: "alibaba",
    model: "glm-5.3",
    endpoint: "virginia",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.131,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.283,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 3.957 },
    ],
  },
  {
    id: "alibaba:glm-5.3:beijing:standard",
    billedBy: "alibaba",
    model: "glm-5.3",
    endpoint: "beijing",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.131,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.283,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 3.957 },
    ],
  },
  {
    id: "alibaba:glm-5.2:singapore:standard",
    billedBy: "alibaba",
    model: "glm-5.2",
    endpoint: "singapore",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.4,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.28,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 4.4 },
    ],
  },
  {
    id: "alibaba:glm-5.2:virginia:standard",
    billedBy: "alibaba",
    model: "glm-5.2",
    endpoint: "virginia",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.1,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.275,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 3.851 },
    ],
  },
  {
    id: "alibaba:glm-5.2:beijing:standard",
    billedBy: "alibaba",
    model: "glm-5.2",
    endpoint: "beijing",
    tier: "standard",
    promptTokensCount: "allInput",
    prices: [
      {
        id: "uncachedInput",
        meter: "uncachedInput",
        unit: "1M tokens",
        currency: "USD",
        amount: 1.1,
      },
      {
        id: "implicitCacheRead",
        meter: "implicitCacheRead",
        unit: "1M tokens",
        currency: "USD",
        amount: 0.275,
      },
      { id: "output", meter: "output", unit: "1M tokens", currency: "USD", amount: 3.851 },
    ],
  },
];
